export const SERVER_ = window.location.protocol+"//"+window.location.hostname+":1338/"
